import { render, staticRenderFns } from "./HandicapRevenueData.vue?vue&type=template&id=8191a61e&scoped=true"
import script from "./HandicapRevenueData.vue?vue&type=script&lang=js"
export * from "./HandicapRevenueData.vue?vue&type=script&lang=js"
import style0 from "./HandicapRevenueData.vue?vue&type=style&index=0&id=8191a61e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8191a61e",
  null
  
)

export default component.exports